export default "__VITE_ASSET__4ff09303__"